import * as Yup from 'yup';
import { get } from 'lodash-es';

import {
  grade,
  className,
  attendanceNumber,
  departmentCategoriesOfInterest,
  collegeWithDepartment,
  consentToSchools,
  inputtedByParentsForJunior,
} from '../common/attributes';

const schoolInfoFormSchema = () =>
  Yup.object().shape({
    school_learner: Yup.lazy((values) =>
      Yup.object().shape({
        grade: grade('grade'),
        class_name: className(),
        attendance_number: attendanceNumber('attendance_number'),
        department_categories_of_interest: departmentCategoriesOfInterest(
          'department_categories_of_interest',
          get(values, 'grade.slug') === 'g12',
        ),
        colleges: collegeWithDepartment(
          'colleges',
          get(values, 'grade.slug') === 'g12',
        ),
        consent_to_schools: consentToSchools('consent_to_schools'),
        inputted_by_parents: inputtedByParentsForJunior(
          'inputted_by_parents',
          get(values, 'grade.junior'),
        ),
      }),
    ),
  });

export default schoolInfoFormSchema;
